module.exports = __webpack_public_path__ + "img/23.976deed4.png";